export default function FormStatus({ status, successText, errorText = "Something went wrong. Please check the form and try again." }) {
  if (!status) return null;
  const isSuccess = status === "success";
  return (
    <div
      className={`border px-4 py-3 text-sm font-semibold ${isSuccess ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-red-200 bg-red-50 text-red-800"}`}
      role="status"
      data-testid={isSuccess ? "form-success-message" : "form-error-message"}
    >
      {isSuccess ? successText : errorText}
    </div>
  );
}